module.exports = __webpack_public_path__ + "assets/images/payspace-not-found-mobile.430b692480ac7af0875189b53c22e66a.webp";